export class CreateApplicationRoutingConstants {
    static CREATE_APPLICATION_ROUTE = "create-application";
    static LOCATION_ROUTE = "location";
    static STAKEHOLDERS_ROUTE = "traders";
    static NOTES_ROUTE = "notes";
    static DETAILS_ROUTE = "details";
    static APPLICANT_ROUTE = "applicantagent";
    static PEOPLE_OF_INTEREST_ROUTE = "peopleofinterest";
    static PROFESSIONAL_BODIES_ROUTE = "professionalbodies";
    static DECEASED_ROUTE = "deceaseddetails";
    static FAMILY_ROUTE = "family";
    static PREMISES_ROUTE = "premises";
    static APPLICANT_EHMS_ROUTE = "applicant";
    static VALUER_ROUTE = "valuerassistantvaluer";
}
